import { Components, Theme } from '@mui/material';
import { getResponsiveFontSize } from '../watchdutyTheme.utils';

export const getMuiButton = (theme: Theme): Components['MuiButton'] => ({
  defaultProps: {
    variant: 'contained',
    color: 'primary',
    disableElevation: true,
    draggable: false,
  },
  styleOverrides: {
    root: ({ ownerState }) => ({
      '& .MuiButton-startIcon, & .MuiButton-endIcon': {
        flexShrink: 0,
      },
      ...(ownerState?.size === 'large' && {
        borderRadius: Number(theme.shape.borderRadius) * 2,
        minHeight: 48,
        fontSize: getResponsiveFontSize('1rem'),
      }),
      ...(ownerState?.variant === 'watchduty-text-uppercase' && {
        textTransform: 'uppercase',
        fontWeight: theme.typography.fontWeightBold,
      }),
      WebkitUserDrag: 'none',
      WebkitTouchCallout: 'none',
    }),
    // MUI defaults use pxToRem(13|15), which scales with iOS Dynamic Type root rem.
    sizeSmall: {
      fontSize: getResponsiveFontSize('0.8125rem'),
    },
    sizeLarge: {
      fontSize: getResponsiveFontSize('0.9375rem'),
    },
    textSizeSmall: {
      fontSize: getResponsiveFontSize('0.8125rem'),
    },
    outlinedSizeSmall: {
      fontSize: getResponsiveFontSize('0.8125rem'),
    },
    containedSizeSmall: {
      fontSize: getResponsiveFontSize('0.8125rem'),
    },
    textSizeLarge: {
      fontSize: getResponsiveFontSize('0.9375rem'),
    },
    outlinedSizeLarge: {
      fontSize: getResponsiveFontSize('0.9375rem'),
    },
    containedSizeLarge: {
      fontSize: getResponsiveFontSize('0.9375rem'),
    },
  },
  variants: [
    {
      props: { variant: 'contained', color: 'contrast' },
      style: {
        color: 'var(--mui-palette-button-contrast-main)',
        backgroundColor: 'var(--mui-palette-button-contrast-dark)',
        border: '1px solid',
        borderColor: 'var(--mui-palette-divider)',
        '&:hover': {
          backgroundColor: 'var(--mui-palette-button-contrast-light)',
          borderColor: 'var(--mui-palette-divider)',
        },
      },
    },
    {
      props: { variant: 'contained', color: 'neutral' },
      style: {
        color: 'var(--mui-palette-button-neutral-main)',
        backgroundColor: 'var(--mui-palette-button-neutral-dark)',
        '&:hover': {
          backgroundColor: 'var(--mui-palette-button-neutral-light)',
        },
      },
    },
    {
      props: { variant: 'outlined', color: 'neutral' },
      style: {
        color: 'var(--mui-palette-text-primary)',
        borderColor: 'var(--mui-palette-text-primary)',
        '&:hover': {
          borderColor: 'var(--mui-palette-text-primary)',
          backgroundColor: 'var(--mui-palette-action-hover)',
        },
      },
    },
    {
      props: { variant: 'contained', color: 'surface' },
      style: {
        borderRadius: Number(theme.shape.borderRadius) * 2,
        padding: theme.spacing(2),
        fontWeight: theme.typography.fontWeightMedium,
        color: 'var(--mui-palette-button-surface-main)',
        backgroundColor: 'var(--mui-palette-button-surface-dark)',
      },
    },
    {
      props: { variant: 'contained', color: 'error' },
      style: {
        color: 'var(--mui-palette-button-error-main)',
        backgroundColor: 'var(--mui-palette-button-error-dark)',
        '&:hover': {
          backgroundColor: 'var(--mui-palette-button-error-light)',
        },
      },
    },
    {
      props: { variant: 'contained', color: 'success' },
      style: {
        color: 'var(--mui-palette-button-success-main)',
        backgroundColor: 'var(--mui-palette-button-success-dark)',
        '&:hover': {
          backgroundColor: 'var(--mui-palette-button-success-light)',
        },
      },
    },
  ],
});
